import React, { useEffect, useMemo, useState } from "react";

// Tilted 3D perspective grid background — a "floor" grid anchored below the
// viewport and rotated steeply on the X axis so it visibly recedes toward a
// vanishing point, rather than reading as a flat rotated 2D pattern.
export default function PerspectiveGrid({
  className = "",
  gridSize = 28,
  showOverlay = true,
  fadeStart = 35,
}) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const tiles = useMemo(() => Array.from({ length: gridSize * gridSize }), [gridSize]);

  return (
    <div
      className={`perspective-grid-wrapper ${className}`.trim()}
      aria-hidden="true"
      style={{
        position: "absolute",
        inset: 0,
        overflow: "hidden",
        pointerEvents: "none",
        zIndex: 0,
        background: "#05050A",
        perspective: "700px",
        perspectiveOrigin: "50% 20%",
      }}
    >
      <style>{`
        .perspective-grid-tile {
          border: 1px solid rgba(255,255,255,0.14);
          background: transparent;
        }
      `}</style>

      <div
        style={{
          position: "absolute",
          left: "50%",
          bottom: "-15%",
          width: "170%",
          aspectRatio: "1 / 1",
          display: "grid",
          transformOrigin: "bottom center",
          transform: "translateX(-50%) rotateX(75deg)",
          gridTemplateColumns: `repeat(${gridSize}, 1fr)`,
          gridTemplateRows: `repeat(${gridSize}, 1fr)`,
        }}
      >
        {mounted && tiles.map((_, i) => <div key={i} className="perspective-grid-tile" />)}
      </div>

      {showOverlay && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            zIndex: 10,
            background: `linear-gradient(to top, transparent ${fadeStart}%, #05050A 95%)`,
          }}
        />
      )}
    </div>
  );
}
